import React from 'react';
import { OrderLinesExpandListTemplate } from 'themes/modules/order/pages';
import { OrderLinesExpandListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new OrderLinesExpandListViewStore(rootStore, componentProps),
	'orderLinesExpandListViewStore'
)
class OrderLinesExpandList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<OrderLinesExpandListTemplate
				{...this.props}
				change={this.props.orderLinesExpandListViewStore.change}
				actions={this.props.orderLinesExpandListViewStore}
				viewStore={this.props.orderLinesExpandListViewStore}
			/>
		);
	}
}

export default OrderLinesExpandList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/OrderLinesExpandList.jsx